import React from 'react';
import PropTypes from 'prop-types';

import { Radio } from 'react-bootstrap';

import ListingSelectedProperty from '../selected_property';
import ListingLeaseInfo from '../lease_info';
import listingPropTypes from '../prop_types';

export default class TenantRepContractDetailsForm extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array,
    listing: listingPropTypes.isRequired,
    onChange: PropTypes.func.isRequired
  };

  handleAssignmentTypeChange = (event) => {
    const { checked, name } = event.target;
    this.props.onChange({
      leaseClosed: false,
      saleClosed: false,
      [name]: checked
    });
  }

  render() {
    return <React.Fragment>
      {this.renderAssignmentType()}
      <ListingSelectedProperty {...this.props} isAssignment />
      {this.renderLeaseInfo()}
    </React.Fragment>;
  }

  renderAssignmentType() {
    const { leaseClosed, saleClosed } = this.props.listing;

    return (
      <div className="form-group required mb-4">
        <label className="control-label">Assignment Type</label>
        <div className="form-inline radio-fields">
          <Radio
            checked={!!leaseClosed}
            className="radio-inline-label radio clear-required"
            id="lease-assignment-type"
            inline
            name="leaseClosed"
            onChange={this.handleAssignmentTypeChange}
          >
            Lease
          </Radio>
          <Radio
            checked={!!saleClosed}
            className="radio-inline-label radio clear-required"
            id="sale-assignment-type"
            inline
            name="saleClosed"
            onChange={this.handleAssignmentTypeChange}
          >
            Sale
          </Radio>
        </div>
      </div>
    );
  }

  renderLeaseInfo() {
    const { listing, onChange } = this.props;

    if (listing.leaseClosed) {
      return (
        <ListingLeaseInfo listing={listing} onChange={onChange} />
      );
    }
  }
}
